import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { useAdmin } from "@/admin/AdminContext";

export function AdminFrame({ title, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative grain">
      <div className="w-full max-w-sm relative">
        <p className="text-[0.6rem] tracking-[0.3em] uppercase text-[var(--muted)]">Banksy Guide · Admin</p>
        <h1 className="font-display text-4xl uppercase mt-2">{title}</h1>
        {children}
      </div>
    </div>
  );
}

export default function AdminLogin() {
  const { admin, signIn } = useAdmin();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [forgot, setForgot] = useState(false);
  const [link, setLink] = useState(null);
  const [busy, setBusy] = useState(false);
  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      if (forgot) {
        const { data } = await api.post("/admin/auth/forgot", { email: form.email });
        setLink(data.link); toast.success(data.message);
      } else {
        const { data } = await api.post("/admin/auth/login", form);
        signIn(data); navigate("/admin");
      }
    } catch (err) { toast.error(errorText(err)); } finally { setBusy(false); }
  };

  return (
    <AdminFrame title={forgot ? "Reset password" : "Sign in"}>
      <form onSubmit={submit} className="mt-8 space-y-3" data-testid="admin-login-form">
        <input className="field" type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="admin-login-email" />
        {!forgot && <input className="field" type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="admin-login-password" />}
        <button type="submit" disabled={busy} className="btn-accent w-full py-3.5" data-testid="admin-login-submit">{forgot ? "Issue reset link" : "Sign in"}</button>
        <button type="button" onClick={() => { setForgot(!forgot); setLink(null); }} className="w-full text-xs text-[var(--muted)] hover:text-white py-2" data-testid="admin-forgot-toggle">{forgot ? "Back to sign in" : "Forgot password?"}</button>
      </form>
      {link && (
        <div className="mt-4 border border-[var(--line)] p-4 text-xs break-all" data-testid="admin-reset-link-box">
          <p className="text-[var(--muted)] mb-2">Test mode: no email is sent. Open this link to set a new password:</p>
          <a href={link} className="text-accent underline" data-testid="admin-reset-link">{link}</a>
        </div>
      )}
    </AdminFrame>
  );
}
